module.exports = __webpack_public_path__ + "static/media/CarolinaSilvaHover.31a177dc.png";